import { usePaymentsStore } from "../../../Payments/store/paymentsStore";
import { useUserPayments } from "../../hooks/useUserPayments";
import { User } from "../../types/user";

export default function PaymentsTab({ user }: { user: User }) {
  const { payments } = usePaymentsStore();
  const userPayments = useUserPayments(payments, { 
    email: user.email || undefined, 
    phone: user.phone || undefined 
  });

  return (
    <div className="w-full bg-card rounded-xl p-4">
      <div className="max-h-96 overflow-y-auto">
        <table className="w-full text-xs table-fixed border-collapse">
          <thead className="sticky top-0 bg-card border-b border-gray-400 text-gray-200 z-10">
            <tr>
              <th className="w-1/6 text-center font-light py-2">Service</th>
              <th className="w-1/6 text-center font-light py-2">Package</th>
              <th className="w-1/6 text-center font-light py-2">Date</th>
              <th className="w-1/6 text-center font-light py-2">Amount</th>
              <th className="w-1/6 text-center font-light py-2">Status</th>
              <th className="w-1/6 text-center font-light py-2">Action</th>
            </tr>
          </thead>
          <tbody className="text-white">
            {userPayments.map((payment, index) => (
              <tr key={index} className="bg-card/50">
                <td className="text-center py-2">{payment.service_name}</td>
                <td className="text-center py-2">{payment.product}</td>
                <td className="text-center py-2">{payment.date}</td>
                <td className="text-center py-2">{payment.amount}</td>
                <td className="text-center py-2">{payment.status}</td>
                <td className="text-center py-2">
                  <button className="bg-none border border-white text-white rounded-lg py-1 px-2 hover:scale-105 cursor-pointer">
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
